/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Button from "uis/Button";
import Modal from "react-modal";
import { theme } from "styles/theme";
import Icon from "uis/Icon";

const modalStyle = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        width: "max-content",
        padding: "50px 50px 30px 50px",
        borderRadius: "20px",
        transform: "translate(-50%, -50%)",
    },
    overlay: {
        backgroundColor: "var(--component-color-material-dimmer)",
        zIndex: 1,
    },
};

Modal.setAppElement("#root");

type Props = {
    modalIsOpen: boolean;
    closeModal: () => void;
    onHandleUpload: () => void;
};

const Content = styled.p`
    color: ${theme.neutral900};
    font-size: 20x;
    font-weight: 500;
    text-align: center;
    line-height: 25px;
`;

const Title = styled.p`
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 12px;
`;

const CSVAlertModal = (props: Props) => {
    const { modalIsOpen, closeModal, onHandleUpload } = props;
    return (
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
            <div
                css={css`
                    display: flex;
                    justify-content: end;
                    position: absolute;
                    right: 20px;
                    top: 20px;
                `}
            >
                <Icon name="close" onClick={() => closeModal()} />
            </div>
            <Title>방문자 CSV 업로드</Title>
            <Content>이미 작성된 내역이 있습니다.</Content>
            <Content>CSV 업로드 시 작성 내역이 모두 사라집니다.</Content>
            <div
                css={css`
                    display: flex;
                    gap: 24px;
                    margin-top: 20px;

                    justify-content: center;
                `}
            >
                <Button
                    onClick={() => closeModal()}
                    title="취소"
                    type="secondary"
                    styles={{
                        container: css`
                            width: 150px;
                            padding: 16px 0;
                            display: flex;
                            align-items: center;
                        `,
                    }}
                />
                <Button
                    onClick={() => {
                        onHandleUpload();
                        closeModal();
                    }}
                    title="업로드하기"
                    type="primary"
                    styles={{
                        container: css`
                            width: 150px;
                            padding: 16px 0;
                            display: flex;
                            align-items: center;
                        `,
                    }}
                />
            </div>
        </Modal>
    );
};

export default CSVAlertModal;
